module.exports = __webpack_public_path__ + "static/media/benefits-platinum.5eb46799.png";